import { Box, Button } from '@mui/material'
import React from 'react'
import { SheetStandardsHandler } from './utilities'
import styled from '@emotion/styled'

export function SheetView({
  sheetStandardsHandler,
  title,
  errors = [],
}: {
  sheetStandardsHandler?: SheetStandardsHandler
  title: string
  errors?: string[]
}) {
  const [addingStandardLists, setAddingStandardLists] = React.useState(false)
  const [addingStandards, setAddingStandards] = React.useState(false)

  function Content() {
    if (sheetStandardsHandler) {
      return (
        <Box>
          <Button
            disabled={addingStandardLists}
            onClick={() => {
              setAddingStandardLists(true)
              sheetStandardsHandler.addStandardListsToLessons().then(() => {
                setAddingStandardLists(false)
              })
            }}
          >
            {addingStandardLists
              ? 'Adding Standard Lists...'
              : 'Add Standard Lists'}
          </Button>
          <Button
            disabled={addingStandards}
            onClick={() => {
              sheetStandardsHandler.addStandards().then(() => {
                setAddingStandards(false)
              })
            }}
          >
            {addingStandards ? 'Adding Standards...' : 'Add Standards'}
          </Button>
          <Box>
            {sheetStandardsHandler.missingStandards.map((e) => (
              <Box>{e}</Box>
            ))}
          </Box>
        </Box>
      )
    }
    if (errors?.length > 0) {
      return (
        <Box>
          <Box>Errors</Box>
          <Box>
            {errors.map((mh) => {
              return <Box>{mh}</Box>
            })}
          </Box>
        </Box>
      )
    }
    return <Box>Processing...</Box>
  }

  return (
    <CustomBox>
      <strong>{title}</strong>
      <Content />
    </CustomBox>
  )
}

const CustomBox = styled(Box)(() => ({
  width: '80%',
  padding: '10px',
  margin: '10px',
  border: '1px solid black',
}))
